'use strict';
import angular from 'angular';
import ngFileUpload from 'ng-file-upload';
import CredentialController from './credential.controller';
import CredentialService from './credential.service';
export default angular.module('directives.credentialForm', [ngFileUpload])
    .service('CredentialService', CredentialService)
    .component('credentialForm', {
    template: require('./credential.html'),
    controller: CredentialController,
    controllerAs: 'cd',
    bindings: {
        credentials: '<',
        onUpdate: '&'
    }
})
    .name;
//# sourceMappingURL=index.js.map